import { useEffect } from "react";
import { bool, string } from "prop-types";
import { observer } from "mobx-react";
import { APP_BAR_ID } from "@utils";
import { useEstimatePresetStore, useEstimateEditorStore, useFonts } from "@tools";
import usePresetEditorStyle from "@tools/EstimateEditor/components/PresetEdition/PresetEditor.style";
import { AppBar, Toolbar } from "@material-ui/core";
import { StaticImg } from "@components";
import { ApropoLogo } from "@assets";
import classnames from "classnames";
import { APP_BAR_HEIGHTS } from "@styles/themes";
import { usePresetStyles } from "@styles";

export const ProposalAppBar = observer(({
  isProposal,
  isPdfPrinterView,
  className
}) => {
  const editorStore = useEstimateEditorStore();
  const presetStore = useEstimatePresetStore();
  const { loadFonts, unloadFonts } = useFonts();
  
  const { proposalStep, companyLogo } = editorStore;
  const { selectedPresetData, selectedPresetFont } = presetStore;
  
  usePresetStyles(selectedPresetData, selectedPresetFont, !!proposalStep || isProposal || isPdfPrinterView, isPdfPrinterView);
  usePresetEditorStyle(proposalStep === 1);
  
  useEffect(() => {
    if(selectedPresetFont && (editorStore.isSharedProposal || proposalStep === 2)) {
      unloadFonts()
      loadFonts([selectedPresetFont])
    }
  }, [proposalStep, selectedPresetFont]);
  
  return (
    <AppBar
      position="static"
      role="banner"
      className={classnames("preset-bar", "shadow-none", className)}
      id={APP_BAR_ID}
    >
      <Toolbar style={{ justifyContent: "space-between" }}>
        <div
          className="preset-logo h-max w-max"
          style={{ maxHeight: APP_BAR_HEIGHTS.SMALL }}
        >
          {presetStore?.selectedPresetData?.logo ? (
            <StaticImg
              // disableCache
              src={presetStore.selectedPresetData.logo}
              style={{ height: APP_BAR_HEIGHTS.SMALL }}
            />
          ) : companyLogo ? (
            <StaticImg
              // disableCache
              src={companyLogo}
              style={{ height: APP_BAR_HEIGHTS.SMALL }}
            />
          ) : (
            <ApropoLogo />
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
});

ProposalAppBar.propTypes = {
  className: string,
  isProposal: bool,
  isPdfPrinterView: bool,
};
